import { loadDataFromElement } from "../utils/hydrate-data";

type FormErrors = { [fieldName: string]: string[] };

export function getFormErrors(): FormErrors {
  return loadDataFromElement<FormErrors>("form-errors", {});
}
